import { graphql } from "gatsby"
import React, { useEffect, useState } from "react"
import SaveModal from "../../shared/components/modals/save-modal/save-modal"
import Layout from "../../shared/components/organisms/layout/layout"
import SEO from "../../shared/seo"
import { siteUrl } from "../../shared/utils/siteUrl"
import { unicodeUtil } from "../../shared/utils/unicodeUtil"
import useMediaQuery from "../../shared/utils/useMediaQuery"
import { reduceArticleSlugs } from "../../utils/alternateUtil"
import PopupArticlesCampaign from "../molecules/popup-articles-campaigns/popup-articles-campaigns"
import ContentArticleFC from "../organisms/content-article-fc/content-article-fc"

const FemaleCareTemplate = props => {
  const isMobile = useMediaQuery()
  const [activeModal, setActiveModal] = useState(null)

  // schema org articles
  const schemaOrgJSONLD = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": siteUrl + props.path,
    },
    headline: unicodeUtil(props.pageContext.metaTitulo),
    description: unicodeUtil(props.pageContext.metaDescripcion.metaDescripcion),
    image: `https:${props.pageContext.metaImagen?.file?.url || ""}`,
    author: {
      "@type": "Organization",
      name: "NosotrasOnline",
    },
    publisher: {
      "@type": "Organization",
      name: "Grupo Familia S.A",
      logo: {
        "@type": "ImageObject",
        url: "/nosotrasonline.png",
        width: "",
        height: "",
      },
    },
    datePublished: props.pageContext.fechaDePublicacion,
    dateModified: props.pageContext.fechaDeActualizacion,
  }

  const setModalState = modal => {
    if (modal || modal === null) {
      setActiveModal(modal)
    } else {
      if (!activeModal) {
        setActiveModal(<SaveModal closeModal={() => setActiveModal(null)} />)
      } else {
        setActiveModal(null)
      }
    }
  }

  useEffect(() => {
    sessionStorage.setItem(
      "LAST_SECTION",
      JSON.stringify({
        title: "Cuidado Femenino",
        slug: "entre-nosotras/cuidado-femenino/",
      })
    )
  }, [])

  useEffect(() => {
    if (typeof window !== `undefined`) {
      if (sessionStorage.getItem("slugFilter") === null) {
        sessionStorage.setItem("slugFilter", "lo-ultimo")
        sessionStorage.setItem("titleFilter", "Lo Último")
      }
    }
  }, [])

  return (
    <Layout title={props.pageContext.metaTitulo} mobile={isMobile} modalActive={activeModal}>
      <PopupArticlesCampaign campaigns={props.pageContext.campaigns} />
      <SEO
        title={props.pageContext.metaTitulo}
        description={props.pageContext.metaDescripcion.metaDescripcion}
        image={
          props.pageContext.metaImagen?.file?.url
            ? `htpps:${props.pageContext.metaImagen?.file?.url}`
            : null
        }
        url={`/entre-nosotras/${props.pageContext.slug}`}
        script={schemaOrgJSONLD}
        alternatesInvalidCountries={
          props.pageContext.paisesDeRestriccionDelArticulo
        }
        alternates={reduceArticleSlugs({
          articles: props.data.allContentfulNolArticulos.nodes,
          countries: props.data.allContentfulNolPaises.nodes,
          category: "entre-nosotras/",
        })}
      />

      <ContentArticleFC
        mobile={isMobile}
        infoArticle={props.pageContext}
        updatedAt={props.pageContext.fechaDeActualizacion}
        setModalState={setModalState}
      />
    </Layout>
  )
}

// export default FemaleCareTemplateCopy

export const query = graphql`
  query GET_ARTICLE_INFO($contentful_id: String!) {
    allContentfulNolArticulos(
      filter: { contentful_id: { eq: $contentful_id } }
    ) {
      nodes {
        contentful_id
        updatedAt
        fechaDePublicacion
        slug
        node_locale
        paisesDeRestriccionDelArticulo
      }
    }
    allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
      nodes {
        dominioDelPais
        codigoIcu
      }
    }
  }
`

export default FemaleCareTemplate
